export default "__VITE_ASSET__BzvaTLsQ__"